import Logo from 'components/logo/Logo'
import React, { useEffect, useState } from 'react'
import FontAwesome from 'react-fontawesome'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import I18n from '../../../resources/i18n/I18n'
import GroupApi from '../../../services/groupApi'
import CustomButton from '../../buttons/CustomButton'
import Title from '../../typo/Title'
import '../configuration.scss'
import EstateUsersEditionTable from './EstateUsersEditionTable'
import './UserTable.scss'

const EstateUserEdition = () => {
  const location = useLocation()
  const history = useHistory()
  const user = useSelector((state) => state.userReducer.user)

  const groupId = new URLSearchParams(location.search).get('groupId')
  const [group, setGroup] = useState(null)

  useEffect(() => {
    if (groupId) {
      GroupApi.getGroupByCode(groupId).then((group) => {
        setGroup(group)
      })
    }
  }, [groupId])

  const goBack = () => {
    history.push('/organismes')
  }

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <Logo />
      </div>
      <Title
        text={`${I18n.t('EstateAgencyConfiguration')}${group && user.roles.indexOf('ORFI-ADMIN') > -1 ? ` : ${group.name || 'Nom inconnu'}` : ''}`}
      />
      <EstateUsersEditionTable groupId={groupId} />
      <div className="row justify-content-center p-4">
        <CustomButton onClick={goBack} icon={<FontAwesome name="arrow-left" />} small secondary />
      </div>
    </div>
  )
}

export default EstateUserEdition
